module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.7070210.woff2";